<template>
  <div class="parciales-container">
    <CardIeaAppMain colorCard="transparent" title="" class="premium-wrapper">
      <v-col cols="12" class="pa-0">
        
        <!-- Hero Header -->
        <div class="hero-header glass-panel mb-4 py-3 px-6 mx-4 mt-4">
          <div class="d-flex align-center justify-space-between w-100 flex-wrap">
            <div class="d-flex align-center mb-2 mb-md-0">
              <v-btn icon dark color="primary" class="mr-4 glass-btn" @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <h1 class="text-h5 font-weight-bold primary-text mb-0">{{ title }}</h1>
                <p class="text-caption grey--text text--darken-1 mb-0 d-none d-sm-block">Listado de parciales, exámenes finales y prácticas disponibles</p>
                <p class="text-caption grey--text text--darken-1 mb-0 d-block d-sm-none">Listado de evaluaciones</p>
              </div>
            </div>
            <v-icon size="48" color="primary" class="opacity-30 d-none d-sm-block">mdi-file-document-edit-outline</v-icon>
          </div>
        </div>

        <v-card class="glass-card rounded-xl overflow-hidden mx-2 mx-sm-4 mb-4" elevation="10">
          <div class="pa-4 pa-sm-6 bg-light min-h-400">
            <div class="d-flex align-center mb-6">
              <v-icon color="primary" class="mr-2">mdi-clipboard-text-clock-outline</v-icon>
              <h2 class="text-h6 font-weight-bold primary-text mb-0">Mis Evaluaciones</h2>
            </div>
            
            <div v-if="examenes_data.length === 0" class="d-flex flex-column align-center justify-center py-10">
               <v-icon size="64" color="grey lighten-1" class="mb-4">mdi-file-hidden</v-icon>
               <h3 class="text-h6 grey--text text--darken-1 font-weight-medium text-center">No hay exámenes disponibles</h3>
               <p class="grey--text text-center mt-2">Los parciales, prácticas o finales aparecerán aquí cuando estén activos.</p>
            </div>

            <div class="d-flex flex-column gap-3" v-else>
              <v-card v-for="(test, keyTable) in examenes_data" :key="keyTable" class="rounded-xl border-light bg-white hover-card overflow-hidden" elevation="0">
                <div class="pa-4 pa-sm-5 d-flex flex-column flex-md-row justify-space-between gap-4">
                  
                  <!-- Info -->
                  <div class="d-flex flex-grow-1 align-start">
                    <div class="icon-wrapper primary-light-bg mr-4 mt-1 flex-shrink-0">
                      <v-icon color="primary">mdi-clipboard-text-outline</v-icon>
                    </div>
                    <div class="w-100">
                      <!-- Titulo y Tipo -->
                      <div class="d-flex flex-wrap align-center gap-2 mb-1">
                        <h3 class="text-subtitle-1 font-weight-bold primary-text mb-0 line-height-1">{{ test.titulo }}</h3>
                        <v-chip small color="info" outlined class="font-weight-bold bg-white" v-if="test.tipo_examen != null">{{ test.tipo_examen }}</v-chip>
                        <v-chip small color="info" outlined class="font-weight-bold bg-white" v-else>Práctica</v-chip>
                      </div>
                      
                      <!-- Materia -->
                      <div class="text-subtitle-2 grey--text text--darken-1 mb-3 d-flex align-center">
                        <v-icon small color="grey" class="mr-1">mdi-book-open-page-variant-outline</v-icon>
                        {{ test.nombreMateria }}
                      </div>
                      
                      <!-- Fechas y Horas -->
                      <div class="d-flex flex-wrap gap-4 mt-2" v-if="test.tipo != 'Practica'">
                        <div class="d-flex flex-column bg-light rounded-lg pa-2">
                          <span class="text-caption grey--text font-weight-bold text-uppercase line-height-1 mb-1">Período Válido</span>
                          <div class="d-flex align-center text-body-2 font-weight-medium primary-text">
                            <v-icon small color="error" class="mr-1">mdi-calendar-range</v-icon>
                            {{ test.fecha_test_desde }} al {{ test.fecha_test_hasta }}
                          </div>
                        </div>
                        <div class="d-flex flex-column bg-light rounded-lg pa-2">
                          <span class="text-caption grey--text font-weight-bold text-uppercase line-height-1 mb-1">Horario Válido</span>
                          <div class="d-flex align-center text-body-2 font-weight-medium primary-text">
                            <v-icon small color="error" class="mr-1">mdi-clock-outline</v-icon>
                            {{ test.hora_inicio }} a {{ test.hora_final }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <!-- Actions and Status -->
                  <div class="d-flex flex-column justify-center align-md-end min-w-max-content border-top-sm border-left-md pl-md-4 pt-4 pt-md-1 gap-3 action-container">
                    
                    <!-- Nota -->
                    <div class="d-flex align-center w-100 justify-md-end" v-if="test.mostrar_nota">
                      <span class="text-caption font-weight-bold grey--text text-uppercase mr-2">Calificación:</span>
                      <v-avatar :color="test.nota >= 4 ? 'success' : 'error'" size="40" class="font-weight-bold white--text shadow-sm">{{ test.nota }}</v-avatar>
                    </div>
                    
                    <!-- Action Buttons -->
                    <div class="d-flex flex-column w-100 gap-2 mt-auto">
                      <!-- Test (Practica) Logic -->
                      <template v-if="test.tipo == 'Practica'">
                        <v-btn rounded class="custom-btn-shadow font-weight-bold px-6 text-none" color="primary" @click="linkTest(test)">
                           <v-icon left>mdi-pencil-outline</v-icon> Presentar Práctica
                        </v-btn>
                      </template>
                      
                      <!-- Test (Examen Final) Logic -->
                      <template v-else-if="test.tipo == 'Examen Final'">
                         <!-- Recuperatorio -->
                         <template v-if="test.tipo_examen == 'Recuperatorio' && test.presentarExamenRecuperatorio">
                           <template v-if="test.testPresentado == false && puedeRendirExamen(test) == true">
                              <v-btn rounded class="custom-btn-shadow font-weight-bold px-6 text-none" color="primary" @click="linkTest(test)">Presentar Examen</v-btn>
                           </template>
                           <template v-else-if="puedeRendirExamen(test) == false">
                              <v-chip color="error" class="font-weight-bold rounded-pill justify-center" outlined>Test Cerrado</v-chip>
                           </template>
                           <template v-else>
                              <v-chip color="success" class="font-weight-bold rounded-pill justify-center bg-success-light" elevation="0">Test Presentado</v-chip>
                           </template>
                         </template>
                         
                         <!-- Examen Final -->
                         <template v-else-if="test.tipo_examen === 'Examen Final' && test.presentarExamenFinal === true">
                           <template v-if="test.testPresentado == false && puedeRendirExamen(test) == true">
                              <v-btn rounded class="custom-btn-shadow font-weight-bold px-6 text-none" color="primary" @click="linkTest(test)">Presentar Examen</v-btn>
                           </template>
                           <template v-else-if="puedeRendirExamen(test) == false">
                              <v-chip color="error" class="font-weight-bold rounded-pill justify-center" outlined>Test Cerrado</v-chip>
                           </template>
                           <template v-else>
                              <v-chip color="success" class="font-weight-bold rounded-pill justify-center bg-success-light" elevation="0">Test Presentado</v-chip>
                           </template>
                         </template>

                         <!-- Parciales -->
                         <template v-else-if="test.tipo_examen == '2do Parcial' || test.tipo_examen == '1er Parcial'">
                           <template v-if="test.testPresentado == false && puedeRendirExamen(test) == true">
                              <v-btn rounded class="custom-btn-shadow font-weight-bold px-6 text-none" color="primary" @click="linkTest(test)">Presentar Examen</v-btn>
                           </template>
                           <template v-else-if="puedeRendirExamen(test) == false">
                              <v-chip color="error" class="font-weight-bold rounded-pill justify-center" outlined>Test Cerrado</v-chip>
                           </template>
                           <template v-else>
                              <v-chip color="success" class="font-weight-bold rounded-pill justify-center bg-success-light" elevation="0">Test Presentado</v-chip>
                           </template>
                         </template>
                      </template>
                      
                      <div class="d-flex gap-2 flex-wrap flex-md-nowrap justify-md-end w-100 mt-2">
                        <!-- En Desarrollo Meet -->
                        <v-btn v-if="test.url_meet" :href="test.url_meet" target="_blank" rounded outlined color="info" class="font-weight-bold text-none flex-grow-1" small>
                          <v-icon left small>mdi-video-outline</v-icon> Clase / Meet
                        </v-btn>
                        
                        <!-- Ver Test -->
                        <v-btn v-if="test.examen_url != null && haPasadoMasDeUnDia(test.fecha_carga) == false" :href="test.examen_url" target="_blank" rounded outlined color="secondary" class="font-weight-bold text-none flex-grow-1" small>
                          <v-icon left small>mdi-file-eye-outline</v-icon> Revisión
                        </v-btn>
                      </div>

                    </div>
                  </div>
                  
                </div>
              </v-card>
            </div>

          </div>
        </v-card>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>
<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";
import moment from "moment";
moment.locale("es");

// Configurar la zona horaria para todas las instancias de moment
moment.fn.toJSON = function () {
    return this.format();
};
moment.parseZone = function (input) {
    return moment(input).utcOffset(-180); // Argentina UTC-3
};
export default {
    name: "ParcialExamen",
    components: {
        CardIeaAppMain
    },
    data() {
        return {
            title: 'Parciales y Exámenes Finales',
            examenes_data: []
        }
    },
    computed: {
        user() {
            return this.$store.getters.user;
        }
    },
    methods: {
        async examenes() {
            await this.$API
                .get({
                    url: "examenes",
                    data: {}
                })
                .then(res => {
                    this.examenes_data = res;

                    // console.log("panel 6", this.panels[6]);
                });
        },
        linkTest(test) {
            this.$router.push({
                name: "examen",
                params: {
                    test: test.test_id,
                    examen: test.id
                }
            });
        },
        puedeRendirExamen(examen) {
            const fechaDesde = moment(
                examen.fecha_test_desde + " " + examen.hora_inicio
            ).utcOffset(-180);
            const fechaHasta = moment(
                examen.fecha_test_hasta + " " + examen.hora_final
            ).utcOffset(-180);
            const now = moment().utcOffset(-180);

            return now.isBetween(fechaDesde, fechaHasta, null, "[]");
        },
        haPasadoMasDeUnDia(fechaCarga) {
            const fechaCargaDate = new Date(fechaCarga);
            const fechaCargaMasUnDia = new Date(
                fechaCargaDate.getTime() + 24 * 60 * 60 * 1000
            ); // Añadir un día
            const now = new Date();
            const unDia = 24 * 60 * 60 * 1000; // Milisegundos en un día

            return now - fechaCargaMasUnDia > unDia;
        },
    },
    mounted() {
        this.examenes()
    }
}
</script>

<style scoped>
/* Glassmorphism Classes (Premium UI) */
.parciales-container { background: transparent !important; min-height: calc(100vh - 120px); }
.glass-panel { background: rgba(255, 255, 255, 0.7) !important; backdrop-filter: blur(16px) !important; border: 1px solid rgba(255, 255, 255, 0.5) !important; box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important; border-radius: 20px; padding: 24px; }
.glass-card { background: rgba(255, 255, 255, 0.85) !important; backdrop-filter: blur(16px) !important; border: 1px solid rgba(255, 255, 255, 0.4) !important; }
.glass-btn { background: rgba(25, 118, 210, 0.1) !important; backdrop-filter: blur(4px) !important; box-shadow: none !important; transition: all 0.3s ease; }
.glass-btn:hover { background: rgba(25, 118, 210, 0.2) !important; transform: translateY(-2px); }
.bg-light { background-color: #f8fafc !important; }
.bg-success-light { background-color: #e8f5e9 !important; border: 1px solid #c8e6c9 !important; }
.border-light { border: 1px solid rgba(0, 0, 0, 0.05) !important; }
.hover-card { transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1); border-left: 4px solid transparent; }
.hover-card:hover { transform: translateY(-4px); box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.12) !important; border-left-color: var(--v-primary-base, #1976d2); }
.shadow-premium { box-shadow: 0 10px 30px -10px rgba(0,0,0,0.08) !important; }
.shadow-sm { box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important; }
.custom-btn-shadow { box-shadow: 0 8px 20px -6px rgba(25, 118, 210, 0.4) !important; transition: all 0.3s ease; }
.custom-btn-shadow:hover { transform: translateY(-2px); box-shadow: 0 12px 25px -6px rgba(25, 118, 210, 0.5) !important; }

/* Utilities */
.line-height-1 { line-height: 1.2; }
.min-w-max-content { min-width: max-content; }
.gap-2 { gap: 8px; }
.gap-3 { gap: 12px; }
.gap-4 { gap: 16px; }

@media (min-width: 960px) {
  .border-left-md { border-left: 1px solid rgba(0, 0, 0, 0.05) !important; }
}

@media (max-width: 959px) {
  .border-top-sm { border-top: 1px solid rgba(0, 0, 0, 0.05) !important; }
}

.action-container { transition: all 0.3s ease; }
.primary-text { color: #1e293b; }
.opacity-30 { opacity: 0.3; }
.w-100 { width: 100%; }
.min-h-400 { min-height: 400px; }

/* Custom elements */
.icon-wrapper { width: 48px; height: 48px; border-radius: 12px; display: flex; align-items: center; justify-content: center; }
.primary-light-bg { background-color: rgba(25, 118, 210, 0.08); }

@media (min-width: 960px) {
  .border-left-md { border-left: 1px solid rgba(0, 0, 0, 0.05) !important; }
}
.action-container .v-btn, .action-container .v-chip { width: 100%; justify-content: center; }
</style>